// extracted by mini-css-extract-plugin
export default {"container":"BusinessBasicsStepContent_container__YaDoK","scrollableContent":"BusinessBasicsStepContent_scrollableContent__kuMF0","notice":"BusinessBasicsStepContent_notice__jN3ow"};